module.exports = __webpack_public_path__ + "static/img/bg.dc5f03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/bg.png
// module id = VtgL
// module chunks = 216